<template>
  <div>
    <div class="mt-1">

      <p class="text-start ms-4 text-secondary">
        Listado de Perfil por Usuarios
      </p>

    
      <div class="d-flex justify-content-end pe-4 mb-2">
        <div class="input-group" style="max-width: 320px;">
          <span class="input-group-text">
            <i class="bi bi-search"></i>
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Buscar usuario o perfil..."
            v-model="searchQuery"
          @input="Filtro"
          >
        </div>
      </div>

      <div class="ps-4 table-responsive">

       
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2 text-secondary">Cargando información...</p>
        </div>

    
        <table v-else class="table mt-0 table-bordered tamañoLetra">
          <thead class="reducirTamaño">
            <tr class="text-nowrap text-white bg-solimano">
              <th>ID</th>
              <th>APELLIDOS Y NOMBRES</th>
              <th>PERFIL</th>
              <th>CREACIÓN</th>
              <th>ACTUALIZACIÓN</th>
              <th><i class="bi bi-boxes fs-5"></i></th>
            </tr>
          </thead>

          <tbody class="text-nowrap text-center texto-fini align-middle">
            <tr
              class="reducirTamaño"
              v-for="lista in paginatedLista"
              :key="lista.idUsuario"
            >
              <td>{{ lista.idUsuario }}</td>
              <td class="text-start">{{ lista.nomUsuario }}</td>
              <td class="text-center">{{ lista.perNombre }}</td>
              <td>{{ lista.audfechaCreacion }}</td>
              <td>{{ lista.audfechaActualizacion }}</td>

              <td class="py-1">

                <button
                  @click="openEditModal(lista.idPerfil, lista.perNombre, lista)"
                  class="btn btn-warning mx-1 py-0 px-2"
                >
                  <i class="bi bi-pencil text-white fs-5"></i>
                </button>

                <button
                  @click="Cambiar(lista.idUsuario)"
                  :class="lista.estado ? 'btn btn-light text-danger' : 'btn btn-light text-success'"
                  class="py-0 px-2"
                >
                  <i :class="lista.estado ? 'bi bi-toggle-off fs-5' : 'bi bi-toggle-on fs-5'"></i>
                </button>

              </td>
            </tr>
          </tbody>
        </table>

     
        <div v-if="!loading" class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

          <button class="btn btn-outline-primary btn-sm"
            @click="currentPage = 1"
            :disabled="currentPage === 1">
            <i class="bi bi-chevron-double-left"></i>
          </button>

          <button class="btn btn-outline-primary btn-sm"
            @click="currentPage--"
            :disabled="currentPage === 1">
            <i class="bi bi-chevron-left"></i>
          </button>

          <span class="pagination-info small">
            Página {{ currentPage }} de {{ totalPages }}
          </span>

          <button class="btn btn-outline-primary btn-sm"
            @click="currentPage++"
            :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-right"></i>
          </button>

          <button class="btn btn-outline-primary btn-sm"
            @click="currentPage = totalPages"
            :disabled="currentPage === totalPages">
            <i class="bi bi-chevron-double-right"></i>
          </button>

        </div>

        <b-modal ref="editModal" centered title="Editar Acceso" hide-footer hide-close-button>
          <div class="mt-3">
            <label>Seleccionar Perfil:</label>
            <select class="form-select mt-2" v-model="idPerfil">
              <option disabled value="">Seleccionar Perfil</option>
              <option
                v-for="item in ListaPerfil"
                :key="item.idPerfil"
                :value="item.idPerfil"
              >
                {{ item.perNombre }}
              </option>
            </select>
          </div>

          <b-button class="mt-3 mx-2" variant="primary" @click="saveChanges">
            Guardar
          </b-button>

          <b-button class="mt-3" variant="secondary" @click="closeEditModal">
            Cerrar
          </b-button>
        </b-modal>

      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters , mapActions } from "vuex";
import Swal from "sweetalert";
export default {
  name: "PowerbyTablaUsuario",

  data() {
    return {
      itemsPerPage: 10, // Cantidad de elementos por página
      currentPage: 1, // Página actual
      idPerfil: "",
      nombrePerfil: "",
      idUsuario: "",
      idUsuarioUnico: "",
       searchQuery: "",
        loading: false
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
  },

  computed: {
    ...mapGetters("acciones", ["ListaPerfil", "ListaPerfilxUsuario"]),

    listaFiltrada() {
      if (!this.searchQuery) return this.ListaPerfilxUsuario;

      return this.ListaPerfilxUsuario.filter(
        (item) =>
          item.nomUsuario.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          item.perNombre.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },

    totalPages() {
      return Math.ceil(this.listaFiltrada.length / this.itemsPerPage);
    },

    paginatedLista() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.listaFiltrada.slice(start, start + this.itemsPerPage);
    }
  
  },

  created() {},

  methods: {
    ...mapActions('acciones' , ['ListarPerfilxUsuario']),
    Cambiar(idperfil) {
      this.axios
        .put(`BIClientes/ModificarEstadoAcceso?idUsuario=${idperfil}`)
        .then((r) => {
          console.log(r.data);
          this.ListarPerfilxUsuario()
        });
    },

    openEditModal(idPerfil, nombre, id) {
      this.idPerfil = idPerfil;
      this.nombrePerfil = nombre;
      this.idUsuarioUnico = id.idUsuario;
      console.log(id);
      this.$refs.editModal.show();
    },

    closeEditModal() {
      this.idPerfil = "";
      this.nombrePerfil = "";
      this.$refs.editModal.hide();
    },

    saveChanges() {
      // Aquí puedes guardar el nombre editado y realizar otras operaciones necesarias
      // Luego, cierra el modal
      const from = {
        idUsuario: this.idUsuarioUnico,
        idPerfil: this.idPerfil,
        idUsuCreacion: this.idUsuario,
      };

      console.log(from);
      this.axios.put(`BIClientes/ModificarAcceso`, from).then((r) => {
        console.log(r.data);

        if(r.data){
          Swal(`Se realizo los cambios`, "", "success");
        this.ListarPerfilxUsuario()
        this.closeEditModal();
        }
       
      });
    },
   Filtro() {
      this.loading = true;
      setTimeout(() => {
        this.currentPage = 1;
        this.loading = false;
      }, 800);
    },
  },
};
</script>

<style scoped>
.b-modal .modal-header button.close {
  display: none;
}
.bg-solimano {
  text-align: center;
  background: #0080c8;
}

strong {
  font-size: 1.64rem;
  color: black;
}

.letra {
  font-weight: 600;
}

/* .icon-selector {
  display: flex;
  gap: 10px;
} */
.bg-iconos {
  background: #f7f7f7;
}

.icon-selector div {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 2px;
}

.icon-selector div.selected {
  border-color: #007bff; /* Color de borde al seleccionar */
}

.icon-selector i {
  font-size: 24px; /* Tamaño de los iconos */
}

.tamañoLetra {
  font-size: 0.8rem;
}
.reducirTamaño {
  font-size: 0.65rem;
}
</style>
